import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from './core/services/auth.service';
import { InactivityService } from './core/services/inactivity.service';
import { DevToolsDetectionService } from './core/services/dev-tools-detection-service.service';
import { API_URL } from './config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'angular-chatbot-project';
  isLoggedIn: boolean = false;
  private loginStatusSubscription: any;

  constructor(
    public authService: AuthService,
    private inactivityService: InactivityService,
    private devToolsDetectionService: DevToolsDetectionService
  ) {
    this.loginStatusSubscription = this.authService.isLoggedIn$.subscribe(val => {
      this.isLoggedIn = val;
      this.handleInactivityTimer(val);
    });

    const isDevEnvironment = API_URL.includes('localhost') || API_URL.includes('chat-dev');

    if (!isDevEnvironment) {
      devToolsDetectionService.startDetection();
      document.addEventListener('contextmenu', e => e.preventDefault());
      document.addEventListener('keydown', e => {
        if (e.key === 'F12') {
          e.preventDefault();
        }
        else if (
          (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key.toUpperCase())) ||
          (e.metaKey && e.altKey && ['I', 'J', 'C'].includes(e.key.toUpperCase()))
        ) {
          e.preventDefault();
        }
        else if (
          (e.ctrlKey && e.key.toUpperCase() === 'U') ||
          (e.metaKey && e.key.toUpperCase() === 'U')
        ) {
          e.preventDefault();
        }
      });
    }

  }

  ngOnInit(): void {
    // console.log('AppComponent initialized. Checking login status and auth token.');
    const loginStatus = localStorage.getItem('isLoggedIn');
    if (loginStatus === 'true' && this.hasAuthToken()) {
      // console.log('User is logged in and has a valid auth token. Starting inactivity timer.');
      this.inactivityService.startInactivityTimer();
    }
  }

  ngOnDestroy(): void {
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }
  }

  private handleInactivityTimer(isLoggedIn: boolean): void {
    if (isLoggedIn && this.hasAuthToken()) {
      this.inactivityService.startInactivityTimer();
    } else {
      this.inactivityService.stopInactivityTimer();
    }
  }

  private hasAuthToken(): boolean {
    return !!sessionStorage.getItem('authToken');
  }
}
